import { cn } from "../../lib/utils";
export function Section({ children, className, id, }) {
    return (<section id={id} className={cn("px-5 py-20 md:py-24", className)}>
      <div className="mx-auto max-w-6xl">{children}</div>
    </section>);
}
export function SectionHeading({ eyebrow, title, description, align = "left", onInk = false, }) {
    return (<div className={cn("max-w-3xl", align === "center" && "mx-auto text-center")}>
      {eyebrow && <p className={cn("eyebrow", onInk ? "text-signal" : "text-foreground")}>{eyebrow}</p>}
      <h2 className="mt-3 text-4xl font-extrabold md:text-5xl lg:text-6xl">{title}</h2>
      {description && (<p className={cn("mt-4 text-lg leading-relaxed", onInk ? "opacity-75" : "text-muted-foreground")}>
          {description}
        </p>)}
    </div>);
}
export function PageHero({ eyebrow, title, description, }) {
    return (<div className="surface-ink px-5 py-20 md:py-24">
      <div className="mx-auto max-w-6xl">
        {eyebrow && <p className="eyebrow text-signal">{eyebrow}</p>}
        <h1 className={cn("max-w-3xl text-4xl font-bold leading-[1.08] md:text-5xl lg:text-6xl", eyebrow ? "mt-4" : "")}>
          {title}
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed opacity-75 md:text-lg">
          {description}
        </p>
      </div>
    </div>);
}
